import React from "react";

import { EventContentArg } from "@fullcalendar/common";

import { fullCalendarViewNameToViewMode } from "@app/component/BaseCalendar";
import CalendarViewMode from "@app/enum/CalendarViewMode";
import loggingService from "@app/util/logging";

import EventObject from "../../type/EventObject";

import DayViewEvent from "./DayViewEvent";
import MonthViewEvent from "./MonthViewEvent";
import Suggestion from "./Suggestion";

interface Props extends EventContentArg {}

const ActivityCalendarEvent: React.FC<Props> = ({ event, view }) => {
  if (event.display === "background" || !Object.keys(event.extendedProps).length) {
    return null;
  }
  const viewMode = fullCalendarViewNameToViewMode[view.type];
  if (!viewMode) {
    loggingService.warning(`Unknown view type in calendar: ${view.type}. Rendering nothing.`);
    return null;
  }

  const payload = event.extendedProps as EventObject;

  if (payload.activity) {
    return viewMode === CalendarViewMode.MONTH ? (
      <MonthViewEvent activity={payload.activity} />
    ) : (
      <DayViewEvent activity={payload.activity} event={event} eventObject={payload} />
    );
  }

  if (payload.suggestion) {
    return <Suggestion suggestion={payload.suggestion} />;
  }

  return null;
};

export default ActivityCalendarEvent;
